import { toast } from 'react-toastify';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { validatePreQualQuestions } from '../../../utilities/preQualServices';

export const fetchPreQualValidate = createAsyncThunk(
    'fetchPreQualValidate', validatePreQualQuestions
)

const initialState = {
    success: {
        preQualData: {
            insuranceType: '',
            diagnosis: '',
            fundId: '',
            fundGroup: '',
        },
        personalInfo: {
            isEPaymentAvailable: false,
            PreQualReportID: ""
        },
        appIntakeSteps: {
            personalInfo: false,
            authorizedPerson: false,
            insurance: false,
            treatment: false,
            authorization: true,
            physicianInfo: false,
            diagnosisInfo: false,
            isDiagnosis: false,
            PrimaryDiagnosisStageRequired: false,
            isPDMI: false,
            VerificationRequired:true,
            DefaultPayee:''
        },
        isSuccess: false
    },
    failiure: {
        fundName: "",
        PreQualQuestionsList: [],
        isFailiure: false,
        message: ""
    }
}

const preQualValidateSlice = createSlice({
    name: 'preQualValidate',
    initialState,
    reducers: {
        resetPreQualValidate: (state, action) => {
            state.success.preQualStatus = false
            state.failiure.isFailiure = false
            state.success.isSuccess = false
        },
        setPreQualData: (state, action) => {
            state.success.preQualData = action.payload;
        },
        resetPreQualSubmitData: (state, action) => {
            state.success = {
                preQualData: {
                    insuranceType: '',
                    diagnosis: '',
                    fundId: '',
                    fundGroup: '',
                },
                personalInfo: {
                    isEPaymentAvailable: false,
                    PreQualReportID: ""
                },
                appIntakeSteps: {
                    personalInfo: false,
                    authorizedPerson: false,
                    insurance: false,
                    treatment: false,
                    authorization: true,
                    physicianInfo: false,
                    diagnosisInfo: false,
                    isDiagnosis: false,
                    PrimaryDiagnosisStageRequired: false,
                    isPDMI: false,
                    VerificationRequired:true,
                    DefaultPayee:''
                },
                isSuccess: false
            }
            state.failiure = {
                fundName: "",
                PreQualQuestionsList: [],
                isFailiure: false,
                message: ""
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPreQualValidate.pending, (state, action) => {
                // toast.warn("PreQualQuestions pending")
            })
            .addCase(fetchPreQualValidate.fulfilled, (state, action) => {
                if (action?.payload?.ResponseDetails?.ResponseCode == "PQ010") {
                    const appintakeconfig = action?.payload?.ResponseDetails?.Fund?.ApplicationConfigurations
                    state.success.personalInfo.isEPaymentAvailable = action?.payload?.ResponseDetails?.Fund?.ClaimsConfigurations?.EPayment?.IsAvailable 
                    state.success.personalInfo.PreQualReportID = action?.payload?.ResponseDetails?.PreQualReportID != undefined ? action?.payload?.ResponseDetails?.PreQualReportID : ""
                    state.success.appIntakeSteps.personalInfo = appintakeconfig?.PatientInformation?.IsRequired && appintakeconfig?.PatientInformation?.IsApplicationIntake
                    state.success.appIntakeSteps.authorizedPerson = state?.success?.appIntakeSteps?.personalInfo
                    state.success.appIntakeSteps.insurance = appintakeconfig?.InsuranceDetails?.IsRequired && appintakeconfig?.InsuranceDetails?.IsApplicationIntake
                    state.success.appIntakeSteps.treatment = (appintakeconfig?.MedicalInformation?.IsApplicationIntake && appintakeconfig?.MedicalInformation?.IsRequired) || (appintakeconfig?.PhysicianDetails?.IsRequired && appintakeconfig?.PhysicianDetails?.IsApplicationIntake)
                    state.success.appIntakeSteps.physicianInfo = appintakeconfig?.PhysicianDetails?.IsRequired && appintakeconfig?.PhysicianDetails?.IsApplicationIntake
                    state.success.appIntakeSteps.diagnosisInfo = appintakeconfig?.MedicalInformation?.IsRequired && appintakeconfig?.MedicalInformation?.IsApplicationIntake
                    state.success.appIntakeSteps.isDiagnosis = appintakeconfig?.MedicalInformation?.IsDiagnosis && appintakeconfig?.MedicalInformation?.IsApplicationIntake
                    state.success.appIntakeSteps.PrimaryDiagnosisStageRequired = appintakeconfig?.MedicalInformation?.PrimaryDiagnosisStageRequired && state?.success?.appIntakeSteps?.diagnosisInfo && state?.success.appIntakeSteps?.isDiagnosis
                    state.success.appIntakeSteps.isPDMI = action?.payload?.ResponseDetails?.Fund?.ClaimsConfigurations?.PDMI?.IsAvailable && action?.payload?.ResponseDetails?.Fund?.ClaimsConfigurations?.PDMI?.IsAvailable
                    state.success.appIntakeSteps.VerificationRequired = action?.payload?.ResponseDetails?.Fund?.ClaimsConfigurations?.ManualClaimSubmission?.VerificationRequired;
                    state.success.appIntakeSteps.DefaultPayee =  action?.payload?.ResponseDetails?.Fund?.ClaimsConfigurations?.ManualClaimSubmission?.DefaultPayee;
                    state.success.isSuccess = true
                    state.failiure.isFailiure = false
                    toast.success("PreQualification successful!")
                } else if (action?.payload?.ResponseDetails?.ResponseCode == "RE001") {
                    state.success.isSuccess = false
                    toast.warn(action?.payload?.ResponseDetails?.ResponseMessage);
                } else {
                    state.success.isSuccess = false
                    state.failiure.isFailiure = true
                    state.failiure.fundName = action?.payload?.ResponseDetails.FundName
                    state.failiure.PreQualQuestionsList = action?.payload?.ResponseDetails.PreQualQuestionsList
                    state.failiure.message = action?.payload?.ResponseDetails?.ResponseMessage
                }
            })
            .addCase(fetchPreQualValidate.rejected, (state, action) => {
                toast.error(action.error.message)
            }) 
    },
})

export const { resetPreQualValidate, setPreQualData,resetPreQualSubmitData } = preQualValidateSlice.actions
export default preQualValidateSlice.reducer